import dayjs from 'dayjs';
import { memo } from 'react';

import { FrameHeader, FrameMessage, WaitTimer } from 'core/ui/Frame';

type TProps = {
  closestTime: string | null;
  exercise: TExercise;
};

const EmptyMessage = ({ closestTime, exercise }: TProps) => {
  return (
    <>
      <FrameHeader>
        {exercise === TExercise.wordCards
          ? 'Exercise: Word Cards'
          : 'Exercise: Tranlsate'}
      </FrameHeader>

      <FrameMessage key="msg">
        nothing to show
        {closestTime && (
          <WaitTimer>
            next one in{' '}
            {closestTime && dayjs(closestTime).diff(dayjs(), 'minute')} min
          </WaitTimer>
        )}
      </FrameMessage>
    </>
  );
};

export default memo(EmptyMessage);
